import $ from 'jquery';
import debounce from '../lib/utils/debounce';

const cartPickerReinit = () => {
    const MARGIN_RIGHT = 20;

    const selectors = {
        list: '.js-cart-picker-selection-list',
        elem: '.js-cart-picker-selection-item',
        btnMore: '.js-cart-picker-more'
    };

    const state = {
        active: 'active'
    };

    function cartPickerReInit() {
        let sumItemVisible = 0;

        const maxWidthList = $(selectors.list).width();

        $(selectors.elem).each((index, item) => {
            sumItemVisible += $(item).width() + MARGIN_RIGHT;
        });

        if (maxWidthList < sumItemVisible) {
            $(selectors.btnMore).addClass(state.active);
        } else {
            $(selectors.btnMore).removeClass(state.active);
        }
    }

    cartPickerReInit();

    const setCartPicker = debounce(() => {
        cartPickerReInit();
    }, 100);

    $(window).on('resize', () => {
        setCartPicker();
    });
};

export default cartPickerReinit;
